<div class="tw:px-8 tw:py-6">
    <div class="">
        <div class="tw:mb-8">
            <h6 class="tw:h6 tw:text-center tw:mb-4">{{ 'INVOICE_ITEM_EDIT_MODAL.title' | translate }}</h6>
            <h6 class="tw:h6 tw:text-center tw:!text-neutral-800">
                {{ item?.itemName }}
            </h6>
        </div>

        <form [formGroup]="form" class="tw:pb-8">
            <div class="tw:mb-4 tw:flex tw:flex-col tw:gap-4 tw:md:flex-row">
                <app-text-input label="{{ 'INVOICE_ITEM_EDIT_MODAL.quantity' | translate }}"
                    [submitAttempted]="submitAttempted"
                    inputType="number"
                    [hasMarginB]="false"
                    formControlName="quantity"
                 />
                <app-text-input label="{{ 'INVOICE_ITEM_EDIT_MODAL.unitPrice' | translate }} ({{ merchantCurrency }})"
                    [submitAttempted]="submitAttempted"
                    inputType="number"
                    [hasMarginB]="false"
                    formControlName="unitPriceCents"
                 />

                <div>
                    <label>{{ 'INVOICE_ITEM_EDIT_MODAL.discount' | translate }}</label>
                    <div class="tw:flex tw:items-center tw:gap-4">
                        <div class="tw:max-w-32">
                            @if (activeTab === 'discountPercentage') {
                                <app-text-input [hideErrorMessage]="true"
                                    [hasMarginB]="false"
                                    [submitAttempted]="submitAttempted"
                                    inputType="number"
                                    formControlName="discountPercentage"
                                 />
                            } @else if (activeTab === 'discountAmountCents') {
                                <app-text-input [hideErrorMessage]="true"
                                    [hasMarginB]="false"
                                    inputType="number"
                                    [submitAttempted]="submitAttempted"
                                    formControlName="discountAmountCents"
                                 />
                            }
                        </div>
                        <app-tab-bar [(activeTab)]="activeTab" [tabOptions]="tabOptions" (tabChanged)="onTabChanged($event)" />
                    </div>
                    @if (activeTab === 'discountPercentage' && form.get('discountPercentage')?.invalid && submitAttempted) {
                        <div class="tw:mt-2 tw:text-sm tw:text-error-500">
                            {{ 'INVOICE_DISCOUNT_MODAL.discountPercentageInvalid' | translate }}
                        </div>
                    }
                    @if (activeTab === 'discountAmountCents' && form.get('discountAmountCents')?.invalid && submitAttempted) {
                        <div class="tw:mt-2 tw:text-sm tw:text-error-500">
                            {{ 'INVOICE_DISCOUNT_MODAL.discountAmountCentsInvalid' | translate }}
                        </div>
                    }
                </div>
            </div>

            @if (vatRatesOptions.length > 0) {
                <div class="tw:flex tw:gap-4">
                    <div class="tw:w-32">
                        <app-dropdown-input-v2 textOption="label"
                            label="{{ 'SHARED.setupStoreProducts.vatRate' | translate }}"
                            formControlName="vatRate"
                            [options]="vatRatesOptions"
                            [submitAttempted]="submitAttempted"
                            placeholder="{{ 'SHARED.setupStoreProducts.vatRatePlaceholder' | translate }}"
                            invalidMsg="{{ 'SHARED.setupStoreProducts.invalidVatRate' | translate }}"
                         />
                    </div>
                    @if (form.get('vatRate')?.value?.value === 0 && vatExemptions.length > 0) {
                        <app-dropdown-input-v2 label="{{ 'SHARED.setupStoreProducts.vatExemption' | translate }}"
                            [submitAttempted]="submitAttempted"
                            [options]="vatExemptions"
                            placeholder="{{ 'SHARED.setupStoreProducts.vatExemption' | translate }}"
                            invalidMsg="{{ 'SHARED.setupStoreProducts.invalidVatExemption' | translate }}"
                            textOption="label"
                            formControlName="vatExemptReason"
                         />
                    }
                </div>
            }

            @if (item.itemType === 'service' || item.itemType === 'product') {
                <div class="tw:mt-8 tw:rounded-md tw:bg-primary-50 tw:p-4">
                    <app-checkbox-input [label]="'INVOICE_ITEM_EDIT_MODAL.hasProviders' | translate" formControlName="hasProviders" size="sm" />

                    @if (form.value.hasProviders && providersArray?.length) {
                        <div formArrayName="providers" class="tw:mt-4 tw:space-y-4">
                            @for (control of providersArray?.controls; let i = $index; track i) {
                                <div [formGroupName]="i" class="tw:flex tw:items-start tw:justify-between tw:gap-4">
                                    <div class="tw:w-full">
                                        <app-dropdown-input-v2 label="{{ 'INVOICE_ITEM_EDIT_MODAL.provider' | translate }}"
                                            [submitAttempted]="submitAttempted"
                                            [options]="availableProvidersForCommissions()"
                                            placeholder=" "
                                            invalidMsg="{{ 'INVOICE_ITEM_EDIT_MODAL.invalidProvider' | translate }}"
                                            textOption="name"
                                            formControlName="provider"
                                         />
                                    </div>

                                    <div class="tw:flex tw:items-center tw:justify-end tw:gap-4">
                                        <app-text-input inputType="number"
                                            extraClass="tw:w-24"
                                            [hasMarginB]="true"
                                            [hideErrorMessage]="true"
                                            [submitAttempted]="submitAttempted"
                                            label="{{ 'INVOICE_ITEM_EDIT_MODAL.commission' | translate }}"
                                            formControlName="commissionValue"
                                            [requiredMark]="false"
                                         />

                                        <button
                                            type="button"
                                            class="btn btn-sm tw:!mt-3"
                                            [class.btn-primary]="providersArray.at(i).get('commissionType')?.value === CommissionTypeOptions.FIXED"
                                            [class.btn-secondary]="providersArray.at(i).get('commissionType')?.value !== CommissionTypeOptions.FIXED"
                                            (click)="providersArray.at(i).patchValue({ commissionType: CommissionTypeOptions.FIXED })"
                                        >
                                            {{ merchantCurrency }}
                                        </button>
                                        <button
                                            type="button"
                                            class="btn btn-sm tw:!mt-3"
                                            [class.btn-primary]="
                                                providersArray.at(i).get('commissionType')?.value === CommissionTypeOptions.PERCENTAGE
                                            "
                                            [class.btn-secondary]="
                                                providersArray.at(i).get('commissionType')?.value !== CommissionTypeOptions.PERCENTAGE
                                            "
                                            (click)="providersArray.at(i).patchValue({ commissionType: CommissionTypeOptions.PERCENTAGE })"
                                        >
                                            %
                                        </button>

                                        <!-- <app-button
                                            extraClass="tw:!mb-0 tw:!px-2 tw:!text-xl tw:mt-2 tw:ml-2"
                                            size="sm"
                                            type="transparent"
                                            (clickEvent)="removeAssociatedProvider(i)"
                                            ><app-icon icon="close"
                                        /></app-button> -->
                                    </div>
                                </div>
                            }
                        </div>
                        <!-- <div class="tw:mt-4 tw:flex tw:justify-center">
                            <app-button type="transparent" size="sm" (clickEvent)="addAssociatedProvider()">
                                <app-icon icon="add_circle" extraClass="tw:mr-2" size="sm" />
                                {{ 'INVOICE_ITEM_EDIT_MODAL.addProvider' | translate }}
                            </app-button>
                        </div> -->
                    }
                </div>
            }
        </form>
    </div>

    <div class="tw:flex tw:justify-center tw:gap-4">
        <button class="btn btn-md btn-secondary" [disabled]="saving()" (click)="close()">{{ 'GENERAL.cancel' | translate }}</button>
        <button class="btn btn-md btn-primary" [disabled]="saving()" (click)="save()">{{ 'GENERAL.save' | translate }}</button>
    </div>
</div>
